import {
  getFormatter,
  InstrumentStorePrice,
  InstrumentStorePriceType,
  isDefined,
  ListedInstrument,
} from '@eih-netbroker/common';
import { ReactComponent as ClosePrice } from '../../../assets/svg/price/close-price.svg';
import { ReactComponent as Delayed } from '../../../assets/svg/price/delayed.svg';
import { ReactComponent as Indicative } from '../../../assets/svg/price/indicative.svg';
import { ReactComponent as LastKnown } from '../../../assets/svg/price/last-known-price.svg';
import { ReactComponent as ReaultimeDown } from '../../../assets/svg/price/realtime-down.svg';
import { ReactComponent as ReaultimeNeutral } from '../../../assets/svg/price/realtime-neutral.svg';
import { ReactComponent as ReaultimeUp } from '../../../assets/svg/price/realtime-up.svg';
import { useLocale } from '../../../context/NbLocalizationContext';
import { cssWhen } from '../../utils/themeUtils';
import { NbTooltip } from '../tooltip/Tooltip';
import classes from './InstrumentMarketPriceDisplay.module.scss';

type InstumentMarketPriceDisplayProps = {
  instrument: ListedInstrument;
  withCurrency: boolean;
  price?: InstrumentStorePrice;
  className?: string;
  priceClassName?: string;
};

export const InstumentMarketPriceDisplay = ({
  instrument,
  withCurrency,
  className,
  price,
  priceClassName,
}: InstumentMarketPriceDisplayProps) => {
  const { translation } = useLocale();
  const { formatCurrency, formatNumberF2 } = getFormatter();

  if (!price) {
    return <></>;
  }

  const { type, value } = price;

  return (
    <span className={cssWhen(classes.container, [isDefined(className), className!])}>
      {type === InstrumentStorePriceType.Delayed && (
        <NbTooltip title={translation.instrument.price.delayed}>
          <Delayed />
        </NbTooltip>
      )}
      {type === InstrumentStorePriceType.ClosePrice && (
        <NbTooltip title={translation.instrument.price.closePrice}>
          <ClosePrice />
        </NbTooltip>
      )}
      {type === InstrumentStorePriceType.IndicativePrice && (
        <NbTooltip title={translation.instrument.price.indicative}>
          <Indicative />
        </NbTooltip>
      )}
      {type === InstrumentStorePriceType.LastKnownPrice && (
        <NbTooltip title={translation.instrument.price.lastKnown}>
          <LastKnown />
        </NbTooltip>
      )}
      {type === InstrumentStorePriceType.FromInstrumentService && (
        <NbTooltip title={translation.instrument.price.lastKnown}>
          <LastKnown />
        </NbTooltip>
      )}
      {type === InstrumentStorePriceType.RealTimeUp && <ReaultimeUp />}
      {type === InstrumentStorePriceType.RealTimeDown && <ReaultimeDown />}
      {type === InstrumentStorePriceType.RealTimeNeutral && <ReaultimeNeutral />}
      <span className={cssWhen([isDefined(priceClassName), priceClassName!])}>
        {withCurrency && formatCurrency(value, instrument)}
        {!withCurrency && formatNumberF2(value)}
      </span>
    </span>
  );
};
